// src/components/SplashScreen.jsx
import React, { useEffect, useState } from 'react';
import styles from './SplashScreen.module.css';

const SplashScreen = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    const splashShown = sessionStorage.getItem('splashShown');
    if (splashShown) {
      setIsVisible(false);
      if (!completed) {
        setCompleted(true);
        onComplete();
      }
      return;
    }

    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        sessionStorage.setItem('splashShown', 'true');
        if (!completed) {
          setCompleted(true);
          onComplete();
        }
      }, 500);
    }, 3500);

    return () => clearTimeout(timer);
  }, [onComplete, completed]);

  if (!isVisible) return null;

  return (
    <div className={styles.splashContainer}>
      <div className={styles.splashBackground}></div>
      
      {/* Desktop particles – shown only on larger screens */}
      <div className={styles.particleDesktop1}>✨</div>
      <div className={styles.particleDesktop2}>🌟</div>
      <div className={styles.particleDesktop3}>🎨</div>
      <div className={styles.particleDesktop4}>🪁</div>
      <div className={styles.particleDesktop5}>🎯</div>
      <div className={styles.particleDesktop6}>🌸</div>
      
      {/* Mobile particles – shown only on small screens */}
      <div className={styles.particleMobile1}>⭐</div>
      <div className={styles.particleMobile2}>🌿</div>
      <div className={styles.particleMobile3}>✨</div>

      <div className={styles.splashContent}>
        <div className={styles.logoWrapper}>
          <div className={styles.logoGlow}></div>
          <img 
            src="/logo2.png" 
            alt="Etikoppaka Toys" 
            className={styles.splashLogo}
          />
          <div className={styles.logoRing}></div>
        </div>
        
        <div className={styles.brandName}>
          <h1>Etikoppaka <span>Toys</span></h1>
          <p className={styles.tagline}>Traditional Handcrafted Wooden Toys</p>
        </div>

        <div className={styles.loadingBar}>
          <div className={styles.loadingFill}></div>
        </div>

        <p className={styles.loadingText}>Bringing heritage to life...</p>
      </div>
    </div>
  );
};

export default SplashScreen;